import { z } from 'zod';
import { ErrorCode } from './error-codes';
/**
 * Required email field: trimmed and lowercased before format validation, so
 * consumers always receive the canonical form used for identity lookups.
 */ export const emailSchema = ()=>z.string().trim().toLowerCase().pipe(z.email(ErrorCode.FIELD_INVALID_EMAIL));
const EMAIL = emailSchema();
/** The canonical email, or null when there is none or it is not an email. */ export function canonicalEmail(email) {
    if (email === null) return null;
    const parsed = EMAIL.safeParse(email);
    return parsed.success ? parsed.data : null;
}
/**
 * Optional email field for create-style requests.
 *
 * Forms bind `''` for an empty input, so `z.input` accepts it; the transform
 * strips it to `undefined` so `''` can never reach the backend or persistence.
 * Factory (not a shared instance) so each schema gets its own call site for
 * future per-feature error customization.
 */ export const optionalEmailSchema = ()=>z.email(ErrorCode.FIELD_INVALID_EMAIL).or(z.literal('')).transform((v)=>v === '' ? undefined : v)// Outer .optional() keeps the KEY optional in the inferred type; an inner
    // .optional() would make `email` a required-but-undefined key, forcing
    // consumers to restate the field just to satisfy the type.
    .optional();

//# sourceMappingURL=email.schema.js.map